<div class="flex flex-wrap justify-center gap-1 w-full mb-4">
  @for (letter of alphabet; track letter) {
    <p-button
      (click)="onLetterClick(letter)"
      [styleClass]="
    'px-2 py-1 rounded text-xs transition-all duration-200 text-white bg-(--p-primary-500) ' +
    (selectedLetter === letter && !disabled
      ? 'bg-(--p-secondary-500) '
      : 'text-gray-800 border-gray-300 ') +
    (isLetterDisabled(letter) ? 'opacity-50 cursor-not-allowed ' : 'hover:bg-gray-200 ') +
    (disabled ? 'opacity-50 cursor-not-allowed' : '')
  "
      [disabled]="isLetterDisabled(letter) || disabled"
      [label]="letter"
    />
  }
</div>

